import React from "react";

export const BpointClosureBadge = ({ closed, invoiceClosed = false }) => closed ? (
  <span className="inline-flex items-center rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700"
    title={invoiceClosed ? "Trimestre BPoint chiuso in Fatturazione" : "Inserimenti BPoint chiusi per gli operatori"}>
    BPoint chiuso
  </span>
) : null;
